import React from 'react';

export const withQueryStringUpdater = (Container, updateUrl: any, moduleName?: string, scenario?: object) => () => <Container updateUrl={updateUrl} moduleName={moduleName} scenario={scenario} />;